import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {
  Badge,
  IconButton,
  CircularProgress
} from '@mui/material';
import React from 'react';

import { useCart } from '../../contexts/CartContext';
import { useFeatureFlag, FEATURE_FLAGS } from '../../hooks/useFeatureFlag';
import { CartDisabled } from '../fallbacks/FeatureDisabled';

export function CartWidget() {
  const cartEnabled = useFeatureFlag(FEATURE_FLAGS.CART);

  // Safely use cart context (only available for authenticated customers)
  let cart = null;
  let loading = false;
  let openCartModal = () => {};
  try {
    const cartContext = useCart();
    cart = cartContext.cart;
    loading = cartContext.loading;
    openCartModal = cartContext.openCartModal;
  } catch (error) {
    console.warn('[CartWidget] CartContext not available, cart functionality disabled:', error);
    // If cart context is not available, don't render the widget
    return null;
  }

  // If cart feature is disabled, show fallback
  if (!cartEnabled) {
    return <CartDisabled />;
  }

  const itemCount = cart?.total_items || 0;

  const handleClick = () => {
    openCartModal();
  };

  return (
    <IconButton
      color="inherit"
      onClick={handleClick}
      disabled={loading}
      sx={{ mr: 1 }}
      title="Shopping Cart"
    >
      <Badge badgeContent={itemCount} color="secondary">
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <ShoppingCartIcon />
        )}
      </Badge>
    </IconButton>
  );
}

export default CartWidget;